<template>
  <el-col :span="24" id="forbidden">
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" class="title">Forbidden</el-row>
      </el-col>
    </el-row> 
    <div class="padding-20">You do not have access to view the page</div>
  </el-col>
</template>

<style scoped>
  .title { font-size: 1.5em; }
  .headerRow { padding: 15px 20px 0px; }
  .sub-title { font-size: 1.1em; font-weight: 600; }
  .padding-20 { text-align: center; margin-top: 200px; }
</style>